<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesQualitySelfInspectResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="left-header">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-bars"
                                            class="btn btn-outline-primary btn-sm"
                                            :disabled="actionDisabled('selectOne')"
                                            show-name custom-label="磨滤区自检"
                                            @click="gotoDetails('mintalMesQualitySelfInspectGrind')">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-bars"
                                            class="btn btn-outline-primary btn-sm"
                                            :disabled="actionDisabled('selectOne')"
                                            show-name custom-label="造球区自检"
                                            @click="gotoDetails('mintalMesQualitySelfInspectPelletize')">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-bars"
                                            class="btn btn-outline-primary btn-sm"
                                            :disabled="actionDisabled('selectOne')"
                                            show-name custom-label="焙烧区自检"
                                            @click="gotoDetails('mintalMesQualitySelfInspectRoast')">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-10-13 14:43:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "mintalMesQualitySelfInspectListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        gotoDetails(entity) {
            this.$_emGotoMixin_gotoHolderList(entity
                , {selfInspectIdFilter: this.selectIds, selfInspectCodeFilter: this.checkedRows[0].code}
                , {selfInspectId: this.selectIds, selfInspectCode: this.checkedRows[0].code}, false, {});
        }
    }
};
</script>